import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
// Confirmation Modal
export default function ConfirmModal(props: any) {
  const { show, onSubmit, onHide, message, title } = props;
  const { t } = useTranslation();
  return (
    <Dialog open={show} onClose={onHide} fullWidth maxWidth="sm">
      <DialogTitle
        style={{
          backgroundColor: "var(--text-primary)",
          color: "#ffffff",
          height: 65,
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent style={{ padding: "12px 24px" }}>{message}</DialogContent>
      <DialogActions>
        <Button
          onClick={onHide}
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#333333",
            textTransform: "capitalize",
          }}
        >
          {t("No")}
        </Button>
        <Button
          onClick={onSubmit}
          variant="contained"
          color="secondary"
          style={{
            backgroundColor: "#D0021B",
            color: "#ffffff",
            textTransform: "capitalize",
          }}
        >
          {t("Yes")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
